module.exports = __webpack_public_path__ + "img/status_4.179af23d.png";